import { configureStore } from "@reduxjs/toolkit";

import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage";
import {
    persistReducer,
    persistStore,
  } from "redux-persist";

  import thunk from "redux-thunk";

import authReducer from './authSlice/authSlice'
import expenseReducer from "./expenseSlice/expenseSlice";

const PersistConfig = {
    key: 'root',
    storage
}


const rootReducer = combineReducers({
    auth: persistReducer(PersistConfig, authReducer),
    expense: expenseReducer
})

const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],
})

export const persistor = persistStore(store)
export default store;